import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface IFavoriteFilterState {
  category: string[];
  discipline: string[];
  setCategory: (category: string[]) => void;
  addCategory: (category: string) => void;
  removeCategory: (category: string) => void;
  setDiscipline: (discipline: string[]) => void;
  addDiscipline: (discipline: string) => void;
  removeDiscipline: (discipline: string) => void;
  resetFilter: () => void;
}

export const favoriteFilterStore = create<IFavoriteFilterState>()(
  persist(
    (set) => ({
      category: [],
      discipline: [],
      setCategory: (category: string[]) => set({ category }),
      addCategory: (category: string) => set((state) => ({ category: [...state.category, category] })),
      removeCategory: (category: string) => set((state) => ({ category: state.category.filter(it => it !== category) })),
      setDiscipline: (discipline: string[]) => set({ discipline}),
      addDiscipline: (discipline: string) => set((state) => ({ discipline: [...state.discipline, discipline] })),
      removeDiscipline: (discipline: string) => set((state) => ({ discipline: state.discipline.filter(it => it !== discipline) })),
      resetFilter: () => set({
        category: [],
        discipline: []
      })
    }),
    {
      name: 'favorites-filters'
    }
  )
);